function MatchHeight() {
     jQuery('[data-type_product_capitalize=true] .grid-product__title').matchHeight();
     jQuery('.megamenu .site-nav__dropdown-link').matchHeight();

  
}


$(document).ready(function() {
  MatchHeight(); 
});


jQuery(document).ready(function($) {
    var offset = 300,
    //browser window scroll (in pixels) after which the "back to top" link opacity is reducedx
    offset_opacity = 1200,
    //duration of the top scrolling animation (in ms)
    scroll_top_duration = 700,
    //grab the "back to top" link
    $back_to_top = $('.cd-top');
//hide or show the "back to top" link
  
$(window).scroll(function() {
    ($(this).scrollTop() > offset) ? $back_to_top.addClass('cd-is-visible'): $back_to_top.removeClass('cd-is-visible cd-fade-out');
    if ($(this).scrollTop() > offset_opacity) {
        $back_to_top.addClass('cd-fade-out');
    }
    if ($(this).scrollTop() > 1) {
        $('.header').addClass("sticky");
		$('.topRightContainer').addClass("sticky");
    } else {
        $('.header').removeClass("sticky");
		$('.topRightContainer').removeClass("sticky");
    }
});
  
//smooth scroll to top
$back_to_top.on('click', function(event) {
		event.preventDefault();
		$('body,html').animate({
				scrollTop: 0,
			}, scroll_top_duration
		);
    });
});
